import { LayoutTemplate, GitFork } from 'lucide-react'

export type ViewMode = 'editorial' | 'technical'

interface ViewToggleProps {
  mode: ViewMode
  onChange: (mode: ViewMode) => void
}

export function ViewToggle({ mode, onChange }: ViewToggleProps) {
  return (
    <div className="flex items-center gap-1 p-1 bg-slate-100 rounded-lg">
      <button
        type="button"
        onClick={() => onChange('editorial')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          mode === 'editorial'
            ? 'bg-white text-slate-800 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        <LayoutTemplate className="w-4 h-4" />
        Vista Editorial
      </button>
      <button
        type="button"
        onClick={() => onChange('technical')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          mode === 'technical'
            ? 'bg-white text-slate-800 shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        <GitFork className="w-4 h-4" />
        Vista Tecnica
      </button>
    </div>
  )
}
